import { v4 as uuidv4 } from "uuid";

import { API, graphqlOperation } from "aws-amplify";
import {
  getOutboundShipment,
  getShipmentLineItemValidate,
} from "../../../../graphql/outbound/custom-queries";
import {
  performUpdateOutboundMini,
  sanitizeOutboundLambda,
  sanitizeShipmentLineItemLambda,
} from "../../../../graphql/outbound/outboundCRUD";

import { maxValue, minValue, number, required } from "react-admin";

import { logError } from "../../../../utils/appUtils";
import { NoteType, ShipmentLineItemStatus } from "../../../../utils/constants";
import { calcNetWeight, updateLambdaInventory } from "../OutboundUtils";
import { trimDecimal } from "../../../../utils/utils";

export const deleteLambdaPickListItem = async (pickListItem) => {
  const shipmentLineItemDeleteList = [];
  const shipmentItemInventoryItemDeleteList = [];
  const inventoryItemUpdateList = [];
  const inventoryUpdateList = [];
  const updateDateTime = new Date().toISOString();
  debugger;

  const shipmentLineItemInput = {
    id: pickListItem.id,
    __typename: "ShipmentLineItem",
  };
  shipmentLineItemDeleteList.push(shipmentLineItemInput);

  pickListItem.inventoryItems.items.forEach((invItem) => {
    const shipmentIteminventoryItemInput = {
      id: invItem.id,
      __typename: "ShipmentLineItemInventoryItem",
      inventoryItemId: invItem.inventoryItemId,
      shipmentLineItemId: invItem.shipmentLineItemId,
    };
    shipmentItemInventoryItemDeleteList.push(shipmentIteminventoryItemInput);

    const toUpdateInventoryItem = {
      ...invItem.inventoryItem,
      updatedAt: updateDateTime,
      quantityCommitted: trimDecimal(
        invItem.inventoryItem.quantityCommitted - invItem.quantityToPick,
        3,
      ),
    };
    delete toUpdateInventoryItem.area;
    delete toUpdateInventoryItem.inventory;
    delete toUpdateInventoryItem.location;
    delete toUpdateInventoryItem.zone;
    inventoryItemUpdateList.push(toUpdateInventoryItem);
  });

  const toUpdateInventory = {
    ...pickListItem.inventory,
    updatedAt: updateDateTime,
    quantityCommitted: trimDecimal(
      pickListItem.inventory.quantityCommitted -
        pickListItem.totalQuantityToPick,
      3,
    ),
  };
  const note = {
    type: NoteType.INVENTORY,
    date: updateDateTime,
    by: window.appUser?.fullName,
    text: `Deleted Outbound Qty. of ${pickListItem.totalQuantityToPick} ${pickListItem.inventory.inventoryUOM}`,
  };
  toUpdateInventory.history = toUpdateInventory.history
    ? [...toUpdateInventory.history, note]
    : [note];
  // index keys not changing on outbound create - no inventory status change
  delete toUpdateInventory.account;
  delete toUpdateInventory.inboundShipment;
  delete toUpdateInventory.shipmentLineItems;
  delete toUpdateInventory.location;
  delete toUpdateInventory.reloadYardCommodity;
  delete toUpdateInventory.product;
  inventoryUpdateList.push(toUpdateInventory);

  return await API.post("transREST", "/outboundDelete", {
    body: {
      shipmentLineItemDeleteList,
      shipmentItemInventoryItemDeleteList,
      inventoryItemUpdateList,
      inventoryUpdateList,
      user: window.appUser.email,
      reloadYardId: window.appUser.reloadYardId,
    },
  });
};

export const updateOutboundQuantity = async (
  outbound,
  data,
  initQty,
  newQty,
) => {
  let outboundRecord = {
    ...outbound,
    invoiceId: outbound.invoiceId ? outbound.invoiceId : " ",
  };
  let historyNote = null;
  debugger;

  try {
    if (outboundRecord?.shipmentLineItems?.items)
      outboundRecord.shipmentLineItems = {
        items: [...outboundRecord.shipmentLineItems.items],
      };
    else outboundRecord.shipmentLineItems = { items: [] };

    if (!outboundRecord) {
      const resp = await API.graphql(
        graphqlOperation(getOutboundShipment, { id: data.outboundShipmentId }),
      );
      outboundRecord = resp.data.getOutboundShipment;
    }

    if (!isNaN(initQty) && !isNaN(newQty) && initQty !== newQty) {
      if (newQty === 0 && outboundRecord?.shipmentLineItems?.items) {
        // item deleted
        outboundRecord.shipmentLineItems.items =
          outboundRecord.shipmentLineItems.items.filter(
            (itm) => itm.id && itm.id !== data.id,
          );
        historyNote = {
          text: `Deleted picklist item with Qty of: ${initQty}`,
          by: window.appUser?.fullName,
          date: new Date(),
          type: NoteType.INVENTORY,
        };
      } else {
        outboundRecord.shipmentLineItems.items =
          outboundRecord.shipmentLineItems.items.map((itm) =>
            itm.id === data.id ? { ...itm, totalQuantityToPick: newQty } : itm,
          );
        historyNote = {
          text: `Picklist item Qty changed from: ${initQty} to  ${newQty}`,
          by: window.appUser?.fullName,
          date: new Date(),
          type: NoteType.INVENTORY,
        };
      }
    }

    outboundRecord.shipmentLineItems.items =
      outboundRecord.shipmentLineItems.items.filter((itm) => itm.id);

    const {
      id,
      active,
      status,
      reloadYardId,
      accountId,
      accountName,
      createDateTime,
      scheduledDateTime,
      arrivalDateTime,
      endDateTime,
      pickupNumber,
      totalUOM,
      weightUnits,
    } = outboundRecord;

    const netWeight = calcNetWeight(outboundRecord, null, weightUnits);

    const history = [...outbound.history, historyNote];

    const outboundInput = {
      id,
      active,
      status,
      reloadYardId,
      accountId,
      accountName,
      createDateTime,
      scheduledDateTime,
      arrivalDateTime,
      endDateTime,
      pickupNumber,
      totalUOM,
      netWeight,
      weightUnits,
      history,
      //updatedAt: not needed for graphQL update
    };
    await performUpdateOutboundMini(outboundInput);
  } catch (err) {
    logError("lineItem:PickListItemUtils:updateOutboundQuantity", err, false);
  }
};

export const getPickListInventoryItemId = (pickListInventoryItem) =>
  pickListInventoryItem?.inventoryItemId || pickListInventoryItem?.inventoryItem?.id;

const sumQuantityToPickByInventoryItemId = (pickListInventoryItems = []) =>
  pickListInventoryItems.reduce((quantityByInventoryItemId, pickListInventoryItem) => {
    const inventoryItemId = getPickListInventoryItemId(pickListInventoryItem);
    if (!inventoryItemId) return quantityByInventoryItemId;

    quantityByInventoryItemId[inventoryItemId] = trimDecimal(
      Number(quantityByInventoryItemId[inventoryItemId] || 0) +
        Number(pickListInventoryItem.quantityToPick || 0),
      3,
    );
    return quantityByInventoryItemId;
  }, {});

export const sumQuantityToPick = (pickListInventoryItems = []) =>
  trimDecimal(
    pickListInventoryItems.reduce(
      (total, pickListInventoryItem) =>
        total + Number(pickListInventoryItem?.quantityToPick || 0),
      0,
    ),
    3,
  );

/**
 * mergePickListRows:
 *
 * Fold freshly picked rows into the rows already on the shipment, keyed by
 * inventory, so one inventory yields one pick-list line item. Merged rows have
 * their inventoryItems deduped by inventoryItemId (first occurrence wins) and
 * their totalQuantityToPick re-summed from the merged set -- a header carried
 * over from before the merge understates the shipment and drifts the inventory
 * and inventoryItem committed quantities apart by the added amount.
 *
 * isLineItemEdit false refuses to merge a fresh pick into a persisted (non-NEW)
 * row: that path sends it down the update branch, which never adjusts committed
 * quantities for the added amount. The per-line-item editor has correct
 * diff-based math, so the caller is pointed at it instead.
 *
 * Rows are merged in place, since the caller hands back the same objects the
 * form is holding.
 */
export const mergePickListRows = (
  shipmentItems = [],
  newShipmentItems = [],
  { isLineItemEdit = false, notify } = {},
) =>
  Object.values(
    [...shipmentItems, ...newShipmentItems].reduce((acc, item) => {
      const mergeKey = item.inventoryId ?? item.inventory?.id;
      if (mergeKey == null || mergeKey === "") {
        logError(
          "outboundShipment:InventorySearchDialog:handleAdd:missingInventoryId",
          new Error(
            "Pick list row missing inventoryId and inventory.id; skipped in merge.",
          ),
          notify,
        );
        return acc;
      }

      const existingRow = acc[mergeKey];
      if (!existingRow) {
        acc[mergeKey] = item;
        return acc;
      }

      if (!isLineItemEdit && existingRow.status !== ShipmentLineItemStatus.NEW) {
        notify &&
          notify(
            `"${existingRow.lotNumber || existingRow.inventoryId}" is already on this shipment. Edit that pick-list line item to change its quantity.`,
            "warning",
          );
        return acc; // skip this inventory; do not merge into a persisted row
      }

      const uniqueLocations = [];
      const mergedLocations = existingRow.inventoryItems.items.concat(
        item.inventoryItems.items,
      );
      mergedLocations.forEach((location) => {
        if (
          !uniqueLocations.some(
            (uniqueLocation) =>
              uniqueLocation.inventoryItemId === location.inventoryItemId,
          )
        ) {
          uniqueLocations.push(location);
        }
      });
      existingRow.inventoryItems.items = uniqueLocations;
      existingRow.totalQuantityToPick = sumQuantityToPick(uniqueLocations);
      return acc;
    }, {}),
  );

const getInventoryItemById = (record, pickListItem) => {
  const inventoryItemById = {};

  const addInventoryItem = (pickListInventoryItem) => {
    const inventoryItemId = getPickListInventoryItemId(pickListInventoryItem);
    if (inventoryItemId && pickListInventoryItem?.inventoryItem) {
      inventoryItemById[inventoryItemId] = pickListInventoryItem.inventoryItem;
    }
  };

  pickListItem?.inventoryItems?.items?.forEach(addInventoryItem);
  record?.inventoryItems?.items?.forEach(addInventoryItem);

  return inventoryItemById;
};

export const calculatePickListQuantityState = (record, pickListItem) => {
  const initialInventoryItems = record?.inventoryItems?.items || [];
  const currentInventoryItems = pickListItem?.inventoryItems?.items || [];
  const initialQuantityByInventoryItemId =
    sumQuantityToPickByInventoryItemId(initialInventoryItems);
  const currentQuantityByInventoryItemId =
    sumQuantityToPickByInventoryItemId(currentInventoryItems);
  const inventoryItemById = getInventoryItemById(record, pickListItem);
  const inventoryItemIds = new Set([
    ...Object.keys(initialQuantityByInventoryItemId),
    ...Object.keys(currentQuantityByInventoryItemId),
  ]);

  const inventoryItemStates = {};
  inventoryItemIds.forEach((inventoryItemId) => {
    const inventoryItem = inventoryItemById[inventoryItemId];
    if (!inventoryItem) return;

    const initialQuantityToPick = Number(
      initialQuantityByInventoryItemId[inventoryItemId] || 0,
    );
    const currentQuantityToPick = Number(
      currentQuantityByInventoryItemId[inventoryItemId] || 0,
    );
    const quantityOnHand = Number(inventoryItem.quantityOnHand || 0);
    const originalQuantityCommitted = Number(
      inventoryItem.quantityCommitted || 0,
    );
    const externalQuantityCommitted = trimDecimal(
      originalQuantityCommitted - initialQuantityToPick,
      3,
    );
    const quantityCommitted = trimDecimal(
      externalQuantityCommitted + currentQuantityToPick,
      3,
    );

    inventoryItemStates[inventoryItemId] = {
      inventoryItem,
      initialQuantityToPick,
      currentQuantityToPick,
      externalQuantityCommitted,
      quantityCommitted,
      quantityAvailable: trimDecimal(quantityOnHand - quantityCommitted, 3),
      maxQuantityToPick: trimDecimal(
        quantityOnHand - externalQuantityCommitted,
        3,
      ),
    };
  });

  const initialTotalQuantityToPick = trimDecimal(
    initialInventoryItems.reduce(
      (total, pickListInventoryItem) =>
        total + Number(pickListInventoryItem.quantityToPick || 0),
      0,
    ),
    3,
  );
  const currentTotalQuantityToPick = trimDecimal(
    currentInventoryItems.reduce(
      (total, pickListInventoryItem) =>
        total + Number(pickListInventoryItem.quantityToPick || 0),
      0,
    ),
    3,
  );
  const externalInventoryQuantityCommitted = trimDecimal(
    Number(record?.inventory?.quantityCommitted || 0) -
      initialTotalQuantityToPick,
    3,
  );
  const inventoryQuantityCommitted = trimDecimal(
    externalInventoryQuantityCommitted + currentTotalQuantityToPick,
    3,
  );

  return {
    inventoryItemStates,
    initialTotalQuantityToPick,
    currentTotalQuantityToPick,
    externalInventoryQuantityCommitted,
    inventoryQuantityCommitted,
    inventoryQuantityAvailable: trimDecimal(
      Number(record?.inventory?.quantityOnHand || 0) -
        inventoryQuantityCommitted,
      3,
    ),
  };
};

export const calculatePickListRowQuantityState = (
  record,
  pickListItem,
  pickListInventoryItem,
) => {
  const inventoryItemId = getPickListInventoryItemId(pickListInventoryItem);
  const currentInventoryItems = pickListItem?.inventoryItems?.items || [];
  const hasCurrentRow = currentInventoryItems.some(
    (currentInventoryItem) =>
      currentInventoryItem === pickListInventoryItem ||
      (currentInventoryItem.id &&
        currentInventoryItem.id === pickListInventoryItem?.id) ||
      getPickListInventoryItemId(currentInventoryItem) === inventoryItemId,
  );
  const quantityPickListItem = hasCurrentRow
    ? pickListItem
    : {
        ...pickListItem,
        inventoryItems: {
          items: [
            ...currentInventoryItems,
            { ...pickListInventoryItem, quantityToPick: 0 },
          ],
        },
      };
  const quantityState = calculatePickListQuantityState(
    record,
    quantityPickListItem,
  );
  const inventoryItemState = quantityState.inventoryItemStates[inventoryItemId];
  const rowQuantityToPick = Number(pickListInventoryItem?.quantityToPick || 0);

  if (!inventoryItemState) {
    return {
      quantityCommitted: 0,
      quantityAvailable: 0,
      maxQuantityToPick: 0,
    };
  }

  return {
    ...inventoryItemState,
    maxQuantityToPick: trimDecimal(
      inventoryItemState.quantityAvailable + rowQuantityToPick,
      3,
    ),
  };
};

export const updateLambdaPickListItem = async (
  record,
  outbound,
  pickListItem,
) => {
  let inventoryUpdateInput = null;
  let outboundUpdateInput = null;
  let shipmentItemUpdateInput = pickListItem;
  const inventoryItemUpdateList = [];
  const shipmentItemInventoryItemCreateList = [];
  const shipmentItemInventoryItemUpdateList = [];
  const shipmentItemInventoryItemDeleteList = [];
  const updateDateTime = new Date().toISOString();
  const newInventoryItems = pickListItem.inventoryItems?.items;
  const initInventoryItems = record.inventoryItems?.items;
  const outboundNotes = [];
  const quantityState = calculatePickListQuantityState(record, pickListItem);
  debugger;

  // check for creates and updates
  for (const invItem of newInventoryItems) {
    if (
      invItem.status === ShipmentLineItemStatus.NEW ||
      invItem.shipmentLineItemId === null
    ) {
      // NEW inventory item added
      const shipmentLineItemInventoryInput = {
        id: invItem.sliiiUuid || uuidv4(), // stable id assigned at add-time; retries re-Put the same row
        __typename: "ShipmentLineItemInventoryItem",
        createdAt: updateDateTime,
        updatedAt: updateDateTime,
        owner: outbound.owner,
        groups: outbound.groups,
        reloadYardId: outbound.reloadYardId,
        outboundShipmentId: outbound.id,
        shipmentLineItemId: pickListItem.id,
        inventoryId: pickListItem.inventoryId,
        inventoryItemId: invItem.inventoryItemId,
        quantityToPick: invItem.quantityToPick,
        status: pickListItem.status,
      };
      shipmentItemInventoryItemCreateList.push(shipmentLineItemInventoryInput);
    } else {
      // existing inventoryItem EDIT
      const initInvItem = initInventoryItems?.find((x) => x.id === invItem.id);
      if (
        initInvItem &&
        invItem.quantityToPick !== initInvItem.quantityToPick
      ) {
        const newQtyToPick = invItem.quantityToPick;

        if (newQtyToPick !== 0) {
          // else item should be deleted
          const shipmentLineItemInventoryItemInput = {
            ...invItem,
            quantityToPick: newQtyToPick,
            status: pickListItem.status,
          };

          delete shipmentLineItemInventoryItemInput.inventoryItem;
          shipmentItemInventoryItemUpdateList.push(
            shipmentLineItemInventoryItemInput,
          );
        }
      }
    }
  }

  // Check for deletes
  for (const invItem of initInventoryItems) {
    const match = newInventoryItems?.find((x) => x.id === invItem.id);
    if (!match || !match.quantityToPick) {
      // inventoryItem was deleted
      shipmentItemInventoryItemDeleteList.push({
        id: invItem.id,
        __typename: "ShipmentLineItemInventoryItem",
        inventoryItemId: invItem.inventoryItemId,
        shipmentLineItemId: invItem.shipmentLineItemId,
      });

      debugger;
    }
  }

  Object.entries(quantityState.inventoryItemStates).forEach(
    ([inventoryItemId, inventoryItemState]) => {
      const inventoryItem = inventoryItemState.inventoryItem;
      const originalQuantityCommitted = Number(
        inventoryItem.quantityCommitted || 0,
      );

      if (
        trimDecimal(originalQuantityCommitted, 3) ===
        trimDecimal(inventoryItemState.quantityCommitted, 3)
      ) {
        return;
      }

      const toUpdateInventoryItem = {
        ...inventoryItem,
        quantityCommitted: inventoryItemState.quantityCommitted,
        updatedAt: updateDateTime,
      };
      const note = {
        type: NoteType.INVENTORY,
        date: updateDateTime,
        by: window.appUser?.fullName,
        text: `Committed quantity changed from ${originalQuantityCommitted} to ${inventoryItemState.quantityCommitted}.`,
      };
      toUpdateInventoryItem.history = toUpdateInventoryItem.history
        ? [...toUpdateInventoryItem.history, note]
        : [note];
      outboundNotes.push(note);

      delete toUpdateInventoryItem.area;
      delete toUpdateInventoryItem.inventory;
      delete toUpdateInventoryItem.location;
      delete toUpdateInventoryItem.zone;
      inventoryItemUpdateList.push(toUpdateInventoryItem);
    },
  );

  const hasPickListItemChanges =
    inventoryItemUpdateList.length > 0 ||
    shipmentItemInventoryItemCreateList.length > 0 ||
    shipmentItemInventoryItemUpdateList.length > 0 ||
    shipmentItemInventoryItemDeleteList.length > 0;

  if (hasPickListItemChanges) {
    // record was edited.
    const initQty = quantityState.initialTotalQuantityToPick;
    const newQty = quantityState.currentTotalQuantityToPick;
    const inventoryUOM = pickListItem.inventory.inventoryUOM;
    const inventoryQuantityCommittedChanged =
      trimDecimal(Number(record.inventory.quantityCommitted || 0), 3) !==
      trimDecimal(quantityState.inventoryQuantityCommitted, 3);

    debugger;
    if (inventoryQuantityCommittedChanged) {
      let toUpdateInventory = {
        ...pickListItem.inventory,
        updatedAt: updateDateTime,
        quantityCommitted: quantityState.inventoryQuantityCommitted,
      };
      const note = {
        type: NoteType.INVENTORY,
        date: updateDateTime,
        by: window.appUser?.fullName,
        text: `Qty. Outbound Changed from ${initQty} ${inventoryUOM} to ${newQty} ${inventoryUOM}.`,
      };
      toUpdateInventory.history = toUpdateInventory.history
        ? [...toUpdateInventory.history, note]
        : [note];

      toUpdateInventory = updateLambdaInventory(
        toUpdateInventory,
        pickListItem,
        false,
        updateDateTime,
      );
      inventoryUpdateInput = toUpdateInventory;
    }

    // Update outbound qtys.
    outboundUpdateInput = {
      ...outbound,
      invoiceId: outbound.invoiceId ? outbound.invoiceId : " ",
      updatedAt: updateDateTime,
    };
    outboundUpdateInput.shipmentLineItems.items =
      outboundUpdateInput.shipmentLineItems.items.map((item) =>
        item.id === pickListItem.id ? pickListItem : item,
      );

    outboundUpdateInput.netWeight = calcNetWeight(
      outboundUpdateInput,
      null,
      outboundUpdateInput.weightUnits,
    );

    if (initQty !== newQty) {
      const note = {
        type: NoteType.INVENTORY,
        date: updateDateTime,
        by: window.appUser?.fullName,
        text: `Picklist qty changed from ${initQty} ${inventoryUOM} to ${newQty} ${inventoryUOM}.`,
      };
      outboundNotes.push(note);
    }
    if (outboundNotes.length > 0) {
      outboundUpdateInput.history = [
        ...outboundUpdateInput.history,
        ...outboundNotes,
      ];
    }

    // sanitize picklistitem and outbound for lambda
    shipmentItemUpdateInput.updatedAt = updateDateTime;
    shipmentItemUpdateInput = sanitizeShipmentLineItemLambda(
      shipmentItemUpdateInput,
    );
    outboundUpdateInput = sanitizeOutboundLambda(outboundUpdateInput);
  }

  const response = await API.post("transREST", "/pickListItemUpdate", {
    body: {
      outboundUpdateInput,
      shipmentItemUpdateInput,
      inventoryUpdateInput,
      inventoryItemUpdateList,
      shipmentItemInventoryItemCreateList,
      shipmentItemInventoryItemUpdateList,
      shipmentItemInventoryItemDeleteList,
      user: window.appUser.email,
      reloadYardId: window.appUser.reloadYardId,
    },
  });
  return response;
};

export const validateQuantity = (min, max) => [
  required(),
  number(),
  minValue(min),
  maxValue(max, "Exceeds Available"),
];

export function getNestedValue(obj, path) {
  return path
    .split(/[.[\]]+/)
    .filter(Boolean)
    .reduce((acc, key) => acc && acc[key], obj);
}

/**
 * validateShipmentLineItemBeforeSave:
 *
 * - UPDATE FLOW (formData.id exists):
 *     • Fetch getShipmentLineItem(id), including:
 *         – shipmentLineItem.updatedAt
 *         – nested inventory { id, updatedAt }
 *         – nested outboundShipment { id, updatedAt }
 *         – nested inventoryItems.items[] { id, updatedAt, inventoryItem { id, updatedAt } }
 *     • Compare server.shipmentLineItem.updatedAt vs. formData.updatedAt
 *     • Compare server.outboundShipment.updatedAt vs. formData.outboundShipment.updatedAt
 *     • Compare server.inventory.updatedAt vs. formData.inventory.updatedAt
 *     • For each serverII in server.inventoryItems.items:
 *         – If missing in formData.inventoryItems.items → stale
 *         – Compare serverII.updatedAt vs. formII.updatedAt
 *         – Compare serverII.inventoryItem.updatedAt vs. formII.inventoryItem.updatedAt
 *
 * - CREATE FLOW (formData.id is falsy):
 *     • Fetch Inventory for formData.inventory.id and compare updatedAt vs. formData.inventory.updatedAt
 *     • For each formII in formData.inventoryItems.items:
 *         – Fetch InventoryItem for formII.inventoryItem.id and compare updatedAt vs. formII.inventoryItem.updatedAt
 *
 * Returns an object { staleErrors: string[] } containing every detected stale error.
 */
export async function validateShipmentLineItemBeforeSave(formState, notify) {
  const formData = formState.values;
  const initData = formState.initialValues;
  const staleErrors = [];

  try {
    let dbSLI;
    const result = await API.graphql(
      graphqlOperation(getShipmentLineItemValidate, { id: formData.id }),
    );
    dbSLI = result.data.getShipmentLineItem;
    if (!dbSLI) {
      staleErrors.push(`Pick List item deleted.`);
      return { staleErrors };
    }

    // 1. Compare SLI.updatedAt
    if (new Date(dbSLI.updatedAt) > new Date(formData.updatedAt)) {
      staleErrors.push(`Pick List item changed.`);
    }

    // 2. Compare outboundShipment
    const formOutbound = formData.outboundShipment;
    const dbOutbound = dbSLI.outboundShipment;
    if (!formOutbound || !dbOutbound) {
      staleErrors.push(`Outbound shipment deleted.`);
    } else if (
      new Date(dbOutbound.updatedAt) > new Date(formOutbound.updatedAt)
    ) {
      staleErrors.push(`Outbound shipment changed.`);
    }

    // 3. Compare Inventory
    const formInv = formData.inventory;
    const dbInv = dbSLI.inventory;
    if (!formInv || !dbInv) {
      logError(
        "outbound:pickListItemUtils:validateShipmentLineItemBeforeSave",
        `Missing inventory data for PickList Item (ID: ${formData.id}).`,
        false,
      );
    } else if (new Date(dbInv.updatedAt) > new Date(formInv.updatedAt)) {
      staleErrors.push(`Inventory: ${formInv.productName} changed.`);
    }

    // 4. Compare each inventoryItem
    const formSLIIIById = {};
    (formData.inventoryItems?.items || []).forEach((ii) => {
      if (ii.id) formSLIIIById[ii.id] = ii;
    });
    const initlSLIIIById = {};
    (initData.inventoryItems?.items || []).forEach((ii) => {
      if (ii.id) initlSLIIIById[ii.id] = ii;
    });

    for (const dbSLIII of dbSLI.inventoryItems?.items || []) {
      const sliiiId = dbSLIII.id;
      let formSLIII = formSLIIIById[sliiiId];

      if (!formSLIII) {
        formSLIII = initlSLIIIById[sliiiId];
        if (!formSLIII) {
          staleErrors.push(`Pick Location record deleted.`);
          continue;
        }
      }

      // 4a. SLIInventoryItem.updatedAt
      if (new Date(dbSLIII.updatedAt) > new Date(formSLIII.updatedAt)) {
        staleErrors.push(
          `Pick Location record ${
            formSLIII.inventoryItem?.locationFullName || ""
          } changed.`,
        );
      }

      // 4b. InventoryItem.updatedAt
      const formInvItem = formSLIII.inventoryItem;
      const dbInvItem = dbSLIII.inventoryItem;
      if (!formInvItem || !dbInvItem) {
        staleErrors.push(`Missing Inventory Location data.`);
      } else if (
        new Date(dbInvItem.updatedAt) > new Date(formInvItem.updatedAt)
      ) {
        staleErrors.push(
          `Location record ${formInvItem.locationFullName || ""} changed.`,
        );
      }
    }
  } catch (err) {
    logError(
      "outbound:pickListItemUtils:validateShipmentLineItemBeforeSave",
      err,
    );
    return {
      staleErrors: [
        "Could not verify the record is up to date. Refresh the page and try again.",
      ],
    };
  }

  return { staleErrors };
}
